import React from 'react';
import type { NumericFormatProps } from 'react-number-format';
import { NumericFormat } from 'react-number-format';
import { useTranslation } from 'react-i18next';

type NumberFormattedProps = NumericFormatProps & {
    value: number | string | null | undefined;
    prefix?: string;
    suffix?: string;
};

export const NumberFormatted = ({
    value,
    prefix,
    suffix,
    ...rest
}: NumberFormattedProps) => {
    const { i18n } = useTranslation();

    const thousandSeparator = i18n.language === 'en' ? ',' : ' ';
    const decimalSeparator = i18n.language === 'en' ? '.' : ',';

    return (
        <NumericFormat
            displayType="text"
            value={value}
            prefix={prefix}
            suffix={suffix}
            thousandSeparator={thousandSeparator}
            decimalSeparator={decimalSeparator}
            {...rest}
        />
    );
};
